import { type PayloadAction, createSlice } from '@reduxjs/toolkit'

export enum PropertyTabs {
  Results = 0,
  Loads = 1,
  Selected = 2,
}

export type SelectedPropertiesTab = {
  currentTab: number
}

const initialState: SelectedPropertiesTab = {
  currentTab: PropertyTabs.Results,
}

export const selectedPropertiesTabSlice = createSlice({
  name: 'selected-properties-tab',
  initialState,
  reducers: {
    setCurrentPropertiesTab: (state, action: PayloadAction<number>) => {
      state.currentTab = action.payload
    },
  },
})

export const { setCurrentPropertiesTab } = selectedPropertiesTabSlice.actions

export default selectedPropertiesTabSlice.reducer
